import React from 'react';
import { FieldArray } from 'redux-form';

import { EDITABLE_LIST_FIELDS_NAME } from 'src/constants/FormNames';

import EditableListField from './EditableListFields';

const EditableList = ({ mode, fieldName, handleSubmit, type }) => (
  <form onSubmit={handleSubmit}>
    <div className="u-mt30">
      <FieldArray
        name={EDITABLE_LIST_FIELDS_NAME}
        component={EditableListField}
        fieldName={fieldName}
        mode={mode}
        type={type}
      />
    </div>
  </form>
);

export default EditableList;
